import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertLiteComponent } from '@lockton-apps/shared/ui/lui';

@Component({
    selector: 'la-delete-contact-requirements-dialog-content',
    imports: [CommonModule, AlertLiteComponent],
    template: `<div class="vstack gap-2">
    <lui-alert-lite
      [compact]="true"
      level="danger"
      *ngIf="canManage"
      data-test="manage-alert"
      i18n
    >
      <span class="fw-b"
        >You are deleting a contact assigned to an enquiry.</span
      >
      <span>
        In order to proceed you must first re-assign the enquiries to another
        contact.
      </span>
    </lui-alert-lite>

    <lui-alert-lite
      [compact]="true"
      level="danger"
      *ngIf="!canManage"
      data-test="cannot-manage-alert"
      i18n
    >
      <span class="fw-b"
        >You are deleting a contact assigned to an enquiry.</span
      >
      <span>
        Please contact your lockton consultant to re-assign the enquiries to
        another contact.
      </span>
    </lui-alert-lite>
  </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteContactRequirementsDialogContentComponent {
  @Input() canManage: boolean = false;
}
